import {
  BasicButton,
  ButtonGroup,
  DangerButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  onBackToHub: () => void;
}

export function ExitClientProfileFormModal(props: Props) {
  const { t } = useTranslation();

  return (
    <>
      <DialogHeader onClose={props.onClose}>
        {t("Client Profile Incomplete")}
      </DialogHeader>
      <DialogContent>
        {t(
          "The client profile is incomplete. All changes will be discarded. Are you sure you want to end session."
        )}
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
          <BasicButton size="medium" onPress={props.onClose}>
            {t("Go back")}
          </BasicButton>
          <DangerButton onPress={props.onBackToHub} size="medium">
            {t("End session")}
          </DangerButton>
        </ButtonGroup>
      </DialogFooter>
    </>
  );
}
